const daysOfWeek = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];

export function getDateWithoutTime(date: Date) {
    date.setHours(0, 0, 0, 0);
    return date;
}

export function getFormattedCurrentTime() {
    const date = new Date();
    let formattedTime = `${date.getHours()}.${date.getMinutes()}`;
    return Number(formattedTime);
}

export function dateToBdFormat(date: Date): string {
    if (date !== null) {
        let month = '' + (date.getMonth() + 1);
        let day = '' + date.getDate();
        let year = date.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    return "";
}

export function formatDate(date: Date) {
    let datestring = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" +
        ("0" + date.getDate()).slice(-2);
    const textDay = daysOfWeek[date.getDay()];

    return textDay + " le " + datestring;
}